module.exports = __webpack_public_path__ + "img/jishudefen.545635dc.png";